module.exports = __webpack_public_path__ + "static/media/air-filter-change.1bc9e80c.svg";